import {Injectable, ViewContainerRef} from '@angular/core';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';

@Injectable()
export class ShowToastyService {

    constructor(private toastyService:ToastyService){
        
    }

    success(title, message){
        var toastOptions:ToastOptions = {
            title: title,
            msg: message,
            showClose: true,
            timeout: 3000,
            theme: 'bootstrap'
          };
        this.toastyService.success(toastOptions);
    }

    failure(title, message){
        var toastOptions:ToastOptions = {
              title: title,
              msg: message,
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
          this.toastyService.error(toastOptions);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/showToastyService.ts